import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import {
  CButton,
  CCardBody,
  CFormTextarea,
  CFormInput,
  CContainer,
  CRow,
  CCol,
} from "@coreui/react";
import "@coreui/coreui/dist/css/coreui.min.css";
import "./landingevac.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import NewCar from "../../assets/evacassets/image/NewCar.png";
import monitoring from "../../assets/evacassets/image/monitor.png";
import green from "../../assets/evacassets/image/green.jpg";
import fast from "../../assets/evacassets/image/fast.jpg";
import motherboard from "../../assets/evacassets/image/motherboard.jpg";
import weather from "../../assets/evacassets/image/weather.png";
import nearBy from "../../assets/evacassets/image/nearby.jpg";
import ev2 from "../../assets/evacassets/image/ev2.jpg";
import ev5 from "../../assets/evacassets/image/ev7.png";
import autocharge from "../../assets/evacassets/image/auto.png";
import map from "../../assets/evacassets/image/image-removebg-preview (2).png";
import store from "../../assets/evacassets/image/image-removebg-preview (1).png";
import ac1 from "../../assets/evacassets/EV-Charger-1.png";
import ac2 from "../../assets/evacassets/EV-Charger-2.png";
import ac3 from "../../assets/evacassets/EV-Charger-3.png";
import videoSrc from "../../assets/evacassets/home.mp4";
import { useNavigate } from "react-router-dom";
import NavbarLogo from "../../assets/evacassets/image/logo.png";
import { FaMicrochip, FaBolt, FaMobileAlt } from "react-icons/fa";
import Footer from "../../Components/footer/Footer";
import PlayStore from "../../assets/evacassets/image/PlayStore.svg";
import AppStore from "../../assets/evacassets/image/AppStore.svg";
// import ChargingImage from "../../assets/evacassets/image/NewCharging1.png";
import ChargingNew from "../../assets/evacassets/image/ChargingNew.png";
import OutSideNavBar from "../outsideNavBar/OutSideNavBar";

const LandingPage = () => {
  const features = [
    {
      icon: <FaMicrochip size={20} color="#007aff" />,
      title: "Advanced Technology",
      description:
        "Experience state-of-the-art technology in EV charging with superior efficiency and reliability.",
    },
    {
      icon: <FaBolt size={20} color="#007aff" />,
      title: "Fast Charging",
      description:
        "Charge your EV rapidly with our advanced fast charging solutions, minimizing downtime.",
    },
    {
      icon: <FaMobileAlt size={20} color="#007aff" />,
      title: "Mobile App Integration",
      description:
        "Easily monitor your charging status and locate stations using our intuitive mobile app.",
    },
  ];

  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const ref1 = useRef(null);
  const isInView1 = useInView(ref1, { once: true });
  const scrollContainerRef = useRef(null);

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const steps = [
    {
      id: 1,
      image: store,
      title: "Download the App",
      description: "Get the app from the App Store or Google Play.",
    },
    {
      id: 2,
      image: map,
      title: "Find a Charger",
      description: "Use our map to locate nearby charging stations.",
    },
    {
      id: 3,
      image: autocharge,
      title: "Start Charging",
      description: "Follow the app instructions to begin charging your EV.",
    },
  ];

  const acChargers = [
    {
      model: "7.4 KW Type 2",
      description: "Reliable home charging with versatile performance.",
      image: ac1,
      priceMonthly: "₹500/month",
      priceTotal: "₹120000",
      features: [
        '3.5" TFT LCD Touch-Screen',
        "Supports remote start via Mobile app/ OTP/ RFID Card",
        "IEC 62196 Type 2 Connector",
        "OCPP 1.6J compliant",
      ],
    },
    {
      model: "11 KW Type 2",
      description: "Efficient and powerful home charging solution",
      image: ac2,
      priceMonthly: "₹2500/month",
      priceTotal: "₹600000",
      features: [
        '3.5" TFT LCD Touch-Screen',
        "Supports remote start via Mobile app/ OTP/ RFID Card",
        "IEC 62196 Type 2 Connector",
        "OCPP 1.6J compliant",
      ],
    },
    {
      model: "22 KW Type 2",
      description: "High-capacity charging for demanding needs",
      image: ac3,
      priceMonthly: "₹5000/month",
      priceTotal: "₹1200000",
      features: [
        '3.5" TFT LCD Touch-Screen',
        "Supports remote start via Mobile app/ OTP/ RFID Card",
        "IEC 62196 Type 2 Connector",
        "OCPP 1.6J compliant",
      ],
    },
  ];

  const nav = useNavigate();
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="landing-container">
      {/* Header */}
      <OutSideNavBar />

      <section id="home" className="hero-section">
        <div className="custom-container">
          <CRow className="align-items-center">
            <CCol md={6} className="hero-content ">
              <motion.div
                initial={{ x: -100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 1 }}
              >
                <h1 className="text-5xl md:text-7xl font-semibold  mb-4">
                  Power Your Drive,
                  <br />
                  The Smarter Way
                </h1>
                <p className="text-[#e0e0e0] text-xl leading-relaxed">
                  Pyramid home charger brings effortless EV charging with
                  real-time monitoring through our app. Your home charging
                  experience is now smarter and safer.
                </p>
              </motion.div>
            </CCol>
          </CRow>
        </div>
      </section>

      {/* <section className="bg-[#f8f7fe] py-16">

        <div className="mx-auto py-8 px-4 sm:px-24 ">
          <div className="flex flex-col md:flex-row items-center md:items-start">
            <div className="w-full md:w-2/3">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
              >
                <p className="text-blue-600 text-sm font-semibold tracking-wide">
                  About Us
                </p>
                <div className="w-16 h-[3px] bg-blue-600 my-2"></div>
                <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mt-4">
                  Pyramid Electronics can trace its roots to the early days of
                  power electronics in India
                </h2>
                <p className="text-gray-600 text-base leading-relaxed mt-4">
                  Pyramid Electronics is a leading electronic design and
                  manufacturing company in India, established in 1993. With over
                  30 years of industry experience, the company has built a
                  reputation for delivering reliable, high-quality solutions
                  across multiple sectors. Its core competencies include the
                  development and manufacturing of grid-tied solar inverters,
                  UPS systems, LED lighting, sheet metal components, fan rods,
                  fabricated fan boxes, concealed boxes, and module boxes—all
                  produced through fully integrated, in-house processes.
                </p>
              </motion.div>
              <button
                onClick={() => nav("/NewAbout")}
                className="mt-8 inline-block border border-gray-800 text-gray-800 hover:bg-gray-800 hover:text-white px-6 py-3 rounded-md text-lg transition"
              >
                Learn more about our story →
              </button>
            </div>

            <div className="hidden md:flex flex-col items-end text-right w-full md:w-1/3 mt-6 md:mt-0">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.3 }}
                className="space-y-6"
              >
                <div>
                  <h3 className="text-3xl font-bold text-gray-900">30+</h3>
                  <p className="text-gray-600">Years Experience</p>
                </div>
                <div>
                  <h3 className="text-3xl font-bold text-gray-900">150+</h3>
                  <p className="text-gray-600">Employees </p>
                </div>
                <div>
                  <h3 className="text-3xl font-bold text-gray-900">100%</h3>
                  <p className="text-gray-600">Quality Focus</p>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section> */}
      <section className="bg-[#f8f7fe] py-16">
        <div className="mx-auto  custom-container py-8">
          <div className="flex flex-col md:flex-row items-center md:items-start">
            <div className="w-full md:w-2/3">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
              >
                <p className="text-blue-600 text-sm font-semibold tracking-wide">
                  About Us
                </p>
                <div className="w-16 h-[3px] bg-blue-600 my-2"></div>
                <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mt-4">
                  Pyramid Electronics can trace its roots to the early days of
                  power electronics in India
                </h2>
                <p className="text-gray-600 text-base leading-relaxed mt-4">
                  Pyramid Electronics is a leading electronic design and
                  manufacturing company in India, established in 1993. With over
                  30 years of industry experience, the company has built a
                  reputation for delivering reliable, high-quality solutions
                  across multiple sectors. Its core competencies include the
                  development and manufacturing of grid-tied solar inverters,
                  UPS systems, LED lighting, sheet metal components, fan rods,
                  fabricated fan boxes, concealed boxes, and module boxes—all
                  produced through fully integrated, in-house processes.
                </p>
              </motion.div>
              <button
                onClick={() => nav("/NewAbout")}
                className="mt-8 inline-block border border-gray-800 text-gray-800 hover:bg-gray-800 hover:text-white px-6 py-3 rounded-md text-lg transition"
              >
                Learn more about our story →
              </button>
            </div>

            <div className="hidden md:flex flex-col items-end text-right w-full md:w-1/3 mt-6 md:mt-0">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.3 }}
                className="space-y-6"
              >
                <div>
                  <h3 className="text-3xl font-bold text-gray-900">30+</h3>
                  <p className="text-gray-600">Years Experience</p>
                </div>
                <div>
                  <h3 className="text-3xl font-bold text-gray-900">150+</h3>
                  <p className="text-gray-600">Employees </p>
                </div>
                <div>
                  <h3 className="text-3xl font-bold text-gray-900">100%</h3>
                  <p className="text-gray-600">Quality Focus</p>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="product" className="products-section">
        <div className=" custom-container mx-auto py-5">
          <div className="flex flex-col md:flex-row justify-between items-start mb-8">
            <h1 className="text-2xl md:text-4xl font-bold text-gray-900 ">
              Our Products
            </h1>
            <div className="products-description text-start text-md-start">
              3.5" TFT LCD Touch-Screen, Supports Remote Start Via Mobile
              App/OTP/RFID Card, IEC 62196 Type 2 Connector And OCPP 1.6J
              Compliant.
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 justify-items-center">
            {acChargers.map((charger, index) => (
              <div
                key={index}
                className="w-full mb-4 flex justify-start justify-content-md-center"
              >
                <div className=" w-full text-left py-4 rounded-lg transition duration-300 ease-in-out transform hover:shadow-md mx-auto hover-card">
                  <div className="product-image-container">
                    <img
                      src={charger.image}
                      alt={charger.model}
                      className="product-image"
                    />
                  </div>
                  <div className="product-line"></div>
                  <h6 className="product-name">{charger.model}</h6>
                  <p className="product-description">{charger.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className=" features-section">
        <CContainer>
          <h2 className="features-title">Unique Key Features</h2>
          <CRow className="justify-content-center">
            {features.map((feature, index) => (
              <CCol key={index} md={4} sm={6} xs={12} className="mb-4">
                <div className="feature-card">
                  <div className="feature-icon-container">{feature.icon}</div>
                  <h6 className="feature-title">{feature.title}</h6>
                  <p className="feature-description">{feature.description}</p>
                </div>
              </CCol>
            ))}
          </CRow>
        </CContainer>
      </section>

      {/* App Section */}
      <section className="app-section">
        <div className="app-container">
          <div className="app-image-container d-none d-md-flex">
            <img
              src={ChargingNew}
              alt="EV Charger"
              className="app-image img-fluid"
              style={{
                maxWidth: "100%",
                height: "auto",
                maxHeight: "550px",
                objectFit: "contain",
              }}
            />{" "}
          </div>
          <div className="w-full md:w-1/2  custom-container bg-black text-[#c9c9c9] flex flex-col justify-center">
            <h1 className="font-bold text-[2.5rem] mb-6 text-white">
              Monitor With App
            </h1>
            <p className="app-subtitle">
              EV charging with real-time monitoring through our app.
            </p>
            <ul className="app-features">
              <li className="app-feature-item">
                <hr />
                <p>Track your charging sessions</p>
              </li>
              <li className="app-feature-item">
                <hr />
                <p>Charging Management</p>
              </li>
              <li className="app-feature-item">
                <hr />
                <p>Remote Charger Control</p>
                <hr />
              </li>
            </ul>
            <div className="flex flex-row justify-center md:justify-start gap-3 mt-12">
              <a
                href="https://apps.apple.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={AppStore}
                  alt="App Store"
                  className="app-store-button img-fluid"
                  style={{ maxWidth: "140px" }}
                />
              </a>
              <a
                href="https://play.google.com/store"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={PlayStore}
                  alt="Google Play"
                  className="play-store-button img-fluid"
                  style={{ maxWidth: "140px" }}
                />
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LandingPage;
